// The other side of an SOP's links on a LIST page (sql/sop-layer.sql manual_links kinds 'drill' / 'regulation'): one read per page,
// then small chips on each row that open the SOP (or manual). Shows nothing without Manuals access or before the SQL has run.
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import { docLabel, isSop, isArchived } from '../lib/manualsCore'

export function openDoc(m) {
  try { localStorage.setItem(isSop(m) ? 'hc_open_sop' : 'hc_open_manual', String(m.id)) } catch (e) {}
  window.dispatchEvent(new CustomEvent('hc:navigate', { detail: { page: isSop(m) ? 'sops' : 'manuals' } }))
}
// kind -> { [target_id]: [manual rows] }
export function useLinkedDocs(kind) {
  const { config } = useAuth()
  const [map, setMap] = useState({})
  useEffect(() => {
    if (!config?.id) return
    let live = true
    ;(async () => {
      const { data: links, error } = await supabase.from('manual_links').select('manual_id,target_id,note').eq('client_id', config.id).eq('kind', kind)
      if (error || !links || !links.length) return
      const { data: ms } = await supabase.from('manuals').select('id,title,doc_kind,doc_number,status,archived_at').in('id', [...new Set(links.map(l => l.manual_id))])
      const by = new Map((ms || []).filter(m => !isArchived(m)).map(m => [m.id, m]))
      const out = {}
      for (const l of links) { const m = by.get(l.manual_id); if (m) (out[String(l.target_id)] = out[String(l.target_id)] || []).push({ ...m, note: l.note }) }
      if (live) setMap(out)
    })()
    return () => { live = false }
  }, [config?.id, kind])
  return map
}
export function DocChips({ docs }) {
  if (!docs || !docs.length) return null
  return <span style={{ display: 'inline-flex', gap: 4, flexWrap: 'wrap', marginLeft: 6 }}>{docs.map(m => (
    <button key={m.id} type="button" onClick={e => { e.stopPropagation(); openDoc(m) }} title={'Open ' + docLabel(m)}
      style={{ fontSize: 10.5, fontWeight: 700, padding: '1px 7px', borderRadius: 10, border: '1px solid rgba(47,107,255,.35)', background: 'rgba(47,107,255,.08)', color: '#2457d6', cursor: 'pointer', fontFamily: 'inherit' }}>{isSop(m) ? m.doc_number || 'SOP' : 'Manual'}{isSop(m) ? '' : ': ' + m.title}</button>
  ))}</span>
}
